import Edit from 'components/Icons/Edit';
import BinTrash from 'components/Icons/BinTrash';

import './Event.scoped.scss';

interface Props {
  name: string;
  date: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Event: React.FC<Props> = ({ name, date }) => {
  return (
    <div className="container">
      <div className="wrapper">
        <h1 className="title">{name}</h1>
        <div className="icons">
          <Edit color="#6e7e97" />
          <BinTrash color="#6e7e97" />
        </div>
      </div>
      <h4 className="created-at">{date}</h4>
    </div>
  );
};

export default Event;
